import { Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';

// this is an anti-pattern and it breaks the redux cycle, it should be avoided
// TODO [refactor]: unify all dispatched error into single error store
export function onActions(
  actions$: Actions,
  actions: string[],
  dispatchId?: string
): Observable<any> {
  return actions$.pipe(
    ofType(...actions),
    filter(({ payload }: any) =>
      dispatchId ? payload.dispatchId === dispatchId : true
    ),
    tap((action: any) => {
      if (action.payload.error) {
        throw action.payload.error;
      }
    }),
    take(1)
  );
}

export interface IDispatchId {
  dispatchId: string;
}

export interface IRequestError extends IDispatchId {
  error: Error;
}

export interface IDispatchResponse extends IDispatchId {
  isSuccess: boolean;
}
